
<div class="main container-fluid">
  <!-- Outer Row -->
  <div class="container especial-container">
    <div class="row justify-content-center especial-row">
      <div class="col-xl-10 col-lg-12 col-md-9">
        <div class="card  border-0 shadow-lg">
          <div class="card-body p-0">
            <!-- Nested Row within Card Body -->
            <div class="row" style="margin: 0;">
              <div class="col-lg-6 d-none d-lg-block login-backgroud">
                <div class="logos-container">
                  <div class="logos">
                    <img src="assets/habitat-nutrition/logo/logo-md.jpg" alt="logo" class="img-fluid">
                  </div>
                </div>
              </div>
                <div class="col-lg-6" style="align-self: center;">
                  <div class="p-4">
                    <div class="text-center" style="margin-bottom: 0.5rem;">
                      <h1 class="h3 text-gray-900" style="font-weight: bolder; margin: 0; padding: 0;">BIENVENIDO</h1>
                      <small>Ingrese sus credenciales</small>
                    </div>
                    <div class="form-group">
                      <input [(ngModel)]="user.username" type="text" class="form-control form-control-user" id="idusr" placeholder="Usuario" (keyup.enter)="keytab($event)">
                    </div>
                    <div class="form-group">
                      <input [(ngModel)]="user.password" type="password" class="form-control form-control-user" id="psw" placeholder="Contraseña" (keyup.enter)="keytab($event)">
                    </div>
                    <button mat-raised-button (click)="singUp()" class="btn btn-user btn-block" style="background-color: var(--app-primary); color: white;" *ngIf="spinner === false">
                      Iniciar Sesión
                    </button>
                    <button class="btn btn-user btn-block" id="loginBtn" style="background-color: var(--app-primary-dark); color: white" type="button" disabled *ngIf="spinner === true" (keyup.enter)="keytab($event)">
                      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      Verificando credenciales ...
                    </button>

                    <br>
                    <br>
                    <div class="form-group login">
                      <div *ngIf="status === 'error'" id="alerta" class="alert alert-danger" role="alert">
                       <span class="message" *ngFor="let error of arrayErrors">
                          <i class="fas fa-exclamation-triangle" style="color: #fff;"></i> {{error}}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div> <!-- first forms-->
    </div>
  </div>
</div> <!-- main container-fluid-->
<app-footer></app-footer>
